<template>
    <!--  OFF CANVAS MENU -->
    <div id="offcanvas-nav" uk-offcanvas="overlay: true">
        <div class="uk-offcanvas-bar">
            <ul class="uk-nav uk-nav-default">
                <li>
                  <router-link to="/" @click.native="menuClickHandler">
                    <span class="uk-margin-small-right" uk-icon="icon: home"></span>
                    {{ $t("Home") }}
                  </router-link>
                </li>
              <div v-if="isLoggedIn && !isMerchantMode">
                <li class="uk-nav-divider"></li>
                <li class="uk-nav-header">{{ $t("Coupons") }}</li>
                <li>
                  <router-link to="/coupons" @click.native="menuClickHandler">
                    <span class="uk-margin-small-right" uk-icon="icon: list"></span>
                    <span :class="linkItemClass">{{ $t("CouponsList") }}</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/coupons/type" @click.native="menuClickHandler">
                    <span class="uk-margin-small-right" uk-icon="icon: info"></span>
                    <span :class="linkItemClass">{{ $t("CouponsType") }}</span>
                  </router-link>
                </li>
                <div v-if="!isHideLoyalty">
                <li class="uk-nav-divider"></li>
                <li class="uk-nav-header">{{ $t("Perks") }}</li>
                <li>
                  <router-link to="/loyalty" @click.native="menuClickHandler">
                    <span class="uk-margin-small-right" uk-icon="icon: list"></span>
                    <span :class="linkItemClass">{{ $t("PerksList") }}</span>
                  </router-link>
                </li>
                </div>
                <li class="uk-nav-divider"></li>
                <li class="uk-nav-header">{{ $t("Locations") }}</li>
                <li>
                  <router-link to="/locations" @click.native="menuClickHandler">
                    <span class="uk-margin-small-right" uk-icon="icon: list"></span>
                    <span :class="linkItemClass">{{ $t("LocationsList") }}</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/locations/map" @click.native="menuClickHandler">
                    <span class="uk-margin-small-right" uk-icon="icon: location"></span>
                    {{ $t("LocationsMap") }}
                  </router-link>
                </li>
                <li class="uk-nav-divider" v-if="appConfig.supportsEgiftCards"></li>
                <li class="uk-nav-header" v-if="appConfig.supportsEgiftCards">{{ $t("GiftCards") }}</li>
                <li v-if="appConfig.supportsEgiftCards">
                  <router-link to="/gift-cards/received" @click.native="menuClickHandler">
                    <svg class="uk-margin-small-right" width="21" height="21" viewBox="0 0 21 21" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.77963 17.3889V13.6677C10.418 13.927 10.9902 14.2884 11.4664 14.7321C11.5317 14.785 11.6183 14.815 11.7087 14.8163C11.7992 14.8176 11.8868 14.7899 11.9542 14.7389C12.0216 14.6878 12.0637 14.6171 12.0722 14.541C12.0806 14.4648 12.0548 14.3887 11.9998 14.328C11.6243 13.9748 11.1948 13.6656 10.7225 13.4088H20.2755V17.3889H9.77963V17.3889ZM4.71359 13.4092H8.11335C7.64083 13.6657 7.21108 13.9745 6.83555 14.3275C6.78995 14.3636 6.75622 14.4091 6.73766 14.4595C6.71911 14.5099 6.71636 14.5635 6.72971 14.6151C6.74305 14.6667 6.77201 14.7145 6.81376 14.7537C6.85551 14.793 6.90861 14.8224 6.96785 14.8391C7.03891 14.8594 7.11569 14.8605 7.18755 14.8423C7.25941 14.8241 7.3228 14.7874 7.36893 14.7374C7.84447 14.2929 8.41704 13.9303 9.05516 13.6694V17.3911H4.71254V13.4092H4.71359V13.4092ZM2.14644 13.4656L3.98912 13.0704V17.1757L3.30507 17.3231L2.14644 13.4643V13.4656ZM4.08309 8.3123C4.02436 8.36682 3.99098 8.4375 3.98912 8.51124V12.4358L1.96952 12.8683L0.811421 9.01303L4.08309 8.31186V8.3123ZM16.6206 8.20484H5.80082L5.7226 7.96238L15.8967 5.77406L16.6212 8.20484H16.6206ZM6.52266 11.8532C6.53449 11.6844 6.61721 11.5247 6.75591 11.4029C6.8946 11.2811 7.08016 11.2052 7.27916 11.1889C7.51059 11.1667 7.74475 11.1999 7.95486 11.285C8.16496 11.37 8.34251 11.5034 8.46719 11.6698C8.7554 12.0015 8.93914 12.3897 9.00056 12.7977C8.55202 12.8198 8.10216 12.7826 7.66712 12.6876C7.37999 12.6349 7.10963 12.5306 6.8744 12.3817C6.776 12.3187 6.69398 12.2393 6.63346 12.1484C6.57294 12.0575 6.53523 11.957 6.52266 11.8532V11.8532ZM9.83108 12.7991C9.89549 12.3937 10.0789 12.0084 10.3645 11.6783C10.5006 11.521 10.6804 11.3946 10.8881 11.3103C11.0958 11.2259 11.3249 11.1862 11.5551 11.1947C11.7533 11.2107 11.9383 11.2857 12.0772 11.4063C12.2161 11.5269 12.2999 11.6853 12.3137 11.8532C12.2987 11.9563 12.2589 12.0558 12.1966 12.1453C12.1342 12.2348 12.0508 12.3126 11.9515 12.3737C11.7162 12.5226 11.4459 12.6271 11.1588 12.6801C10.7237 12.7749 10.2738 12.8119 9.82531 12.7897L9.83003 12.7986H9.83108V12.7991ZM4.71306 8.81675H9.05674V11.2893C8.84489 11.0493 8.56511 10.8582 8.24312 10.7336C7.92113 10.6089 7.56726 10.5548 7.21406 10.5761C6.82984 10.6071 6.47278 10.7573 6.2118 10.9978C5.95081 11.2383 5.8044 11.5521 5.80082 11.8785C5.81759 12.0551 5.87548 12.2272 5.97117 12.3848C6.06685 12.5424 6.19843 12.6824 6.35835 12.7969H4.71254V8.81675H4.71306ZM5.01755 8.10981L5.0459 8.20484H4.57552L5.01703 8.10981H5.01755ZM20.275 12.7969H12.4759C12.6366 12.6828 12.769 12.5429 12.8653 12.3853C12.9617 12.2276 13.0201 12.0554 13.0371 11.8785C13.0349 11.5534 12.8907 11.2404 12.6323 10.9997C12.3738 10.759 12.0194 10.6075 11.637 10.5743C11.2812 10.5507 10.9241 10.604 10.5992 10.729C10.2743 10.8541 9.99234 11.0468 9.77963 11.2893V8.81675H20.2755V12.7969H20.275ZM20.6372 8.20528H17.3797L16.5135 5.32423C16.4892 5.24565 16.4291 5.17837 16.3465 5.13704C16.2638 5.09571 16.1652 5.08367 16.072 5.10353L0.278568 8.51124C0.187229 8.52939 0.107827 8.5769 0.0571693 8.6437C0.00651143 8.7105 -0.0114261 8.79136 0.00715382 8.86915L2.68192 17.7743C2.71174 17.8498 2.77276 17.9136 2.85378 17.9541C2.9348 17.9946 3.03036 18.0089 3.1229 17.9946L4.00277 17.8045C4.02968 17.8635 4.07755 17.914 4.1398 17.9489C4.20205 17.9839 4.27559 18.0017 4.3503 17.9999H20.6372C20.7329 17.9999 20.8248 17.9679 20.8926 17.9108C20.9605 17.8537 20.9989 17.7762 20.9995 17.6953V8.51124C20.9995 8.42998 20.9613 8.35204 20.8934 8.29458C20.8254 8.23712 20.7333 8.20484 20.6372 8.20484V8.20528Z" fill="currentColor"/>
                      <path d="M17.018 15.5522H18.4665C18.5601 15.5492 18.6487 15.5156 18.7136 15.4585C18.7786 15.4014 18.8149 15.3253 18.8149 15.246C18.8149 15.1668 18.7786 15.0906 18.7136 15.0335C18.6487 14.9765 18.5601 14.9429 18.4665 14.9399H17.0186C16.9225 14.9399 16.8304 14.9721 16.7624 15.0296C16.6945 15.0871 16.6563 15.165 16.6563 15.2463C16.6563 15.3275 16.6945 15.4055 16.7624 15.4629C16.8304 15.5204 16.9225 15.5527 17.0186 15.5527L17.018 15.5522ZM19.1894 16.1641H16.2941C16.198 16.1641 16.1059 16.1964 16.038 16.2539C15.97 16.3113 15.9319 16.3893 15.9319 16.4705C15.9319 16.5518 15.97 16.6297 16.038 16.6872C16.1059 16.7446 16.198 16.7769 16.2941 16.7769H19.1894C19.2854 16.7769 19.3776 16.7446 19.4455 16.6872C19.5134 16.6297 19.5516 16.5518 19.5516 16.4705C19.5516 16.3893 19.5134 16.3113 19.4455 16.2539C19.3776 16.1964 19.2854 16.1641 19.1894 16.1641V16.1641ZM19.0088 4.22516C19.1048 4.22516 19.197 4.19288 19.2649 4.13542C19.3328 4.07795 19.371 4.00002 19.371 3.91876V3.3064C19.371 3.22514 19.3328 3.1472 19.2649 3.08974C19.197 3.03228 19.1048 3 19.0088 3C18.9127 3 18.8206 3.03228 18.7526 3.08974C18.6847 3.1472 18.6465 3.22514 18.6465 3.3064V3.9192C18.6467 4.00039 18.6849 4.07821 18.7528 4.13557C18.8207 4.19294 18.9128 4.22516 19.0088 4.22516ZM18.1042 4.99027C18.2003 4.99027 18.2924 4.95799 18.3604 4.90053C18.4283 4.84307 18.4665 4.76513 18.4665 4.68387C18.4665 4.60261 18.4283 4.52467 18.3604 4.46721C18.2924 4.40975 18.2003 4.37747 18.1042 4.37747H17.3803C17.2842 4.37747 17.1921 4.40975 17.1241 4.46721C17.0562 4.52467 17.018 4.60261 17.018 4.68387C17.018 4.76513 17.0562 4.84307 17.1241 4.90053C17.1921 4.95799 17.2842 4.99027 17.3803 4.99027H18.1048H18.1042ZM18.6471 6.06179C18.6452 6.10298 18.6532 6.14406 18.6705 6.18257C18.6879 6.22109 18.7143 6.25625 18.7481 6.28594C18.7819 6.31564 18.8224 6.33926 18.8672 6.3554C18.9121 6.37153 18.9603 6.37985 19.009 6.37985C19.0578 6.37985 19.106 6.37153 19.1508 6.3554C19.1957 6.33926 19.2362 6.31564 19.27 6.28594C19.3038 6.25625 19.3302 6.22109 19.3475 6.18257C19.3649 6.14406 19.3729 6.10298 19.371 6.06179V5.44899C19.371 5.36772 19.3328 5.28979 19.2649 5.23233C19.197 5.17487 19.1048 5.14258 19.0088 5.14258C18.9127 5.14258 18.8206 5.17487 18.7526 5.23233C18.6847 5.28979 18.6465 5.36772 18.6465 5.44899V6.06179H18.6471ZM20.6373 4.37792H19.9133C19.8197 4.38093 19.7311 4.41451 19.6661 4.4716C19.6012 4.52869 19.5649 4.60485 19.5649 4.68409C19.5649 4.76334 19.6012 4.8395 19.6661 4.89659C19.7311 4.95368 19.8197 4.98726 19.9133 4.99027H20.6378C20.7338 4.99027 20.826 4.95799 20.8939 4.90053C20.9618 4.84307 21 4.76513 21 4.68387C21 4.60261 20.9618 4.52467 20.8939 4.46721C20.826 4.40975 20.7338 4.37747 20.6378 4.37747L20.6373 4.37792ZM1.63617 4.53112V5.14303C1.63617 5.22429 1.67434 5.30223 1.74227 5.35969C1.8102 5.41715 1.90234 5.44943 1.99841 5.44943C2.09448 5.44943 2.18662 5.41715 2.25455 5.35969C2.32248 5.30223 2.36064 5.22429 2.36064 5.14303V4.53112C2.36064 4.44985 2.32248 4.37192 2.25455 4.31446C2.18662 4.257 2.09448 4.22471 1.99841 4.22471C1.90234 4.22471 1.8102 4.257 1.74227 4.31446C1.67434 4.37192 1.63617 4.44985 1.63617 4.53112V4.53112ZM0.369926 6.21454H1.0923C1.18837 6.21454 1.2805 6.18226 1.34844 6.1248C1.41637 6.06734 1.45453 5.9894 1.45453 5.90814C1.45453 5.82688 1.41637 5.74895 1.34844 5.69148C1.2805 5.63402 1.18837 5.60174 1.0923 5.60174H0.369926C0.273855 5.60174 0.181719 5.63402 0.113787 5.69148C0.0458544 5.74895 0.00769043 5.82688 0.00769043 5.90814C0.00769043 5.9894 0.0458544 6.06734 0.113787 6.1248C0.181719 6.18226 0.273855 6.21454 0.369926 6.21454V6.21454ZM2.00051 6.36774C1.95292 6.36768 1.90579 6.37557 1.86181 6.39095C1.81783 6.40633 1.77787 6.42889 1.74422 6.45736C1.71057 6.48582 1.68389 6.51962 1.66571 6.55682C1.64753 6.59402 1.6382 6.63389 1.63827 6.67414V7.28561C1.64599 7.36209 1.68736 7.43333 1.75419 7.48524C1.82103 7.53715 1.90846 7.56595 1.9992 7.56595C2.08993 7.56595 2.17737 7.53715 2.2442 7.48524C2.31104 7.43333 2.3524 7.36209 2.36012 7.28561V6.67414C2.36012 6.59326 2.32232 6.51567 2.25495 6.45827C2.18759 6.40087 2.09612 6.36833 2.00051 6.36774V6.36774ZM2.54124 5.90859C2.54138 5.9897 2.57953 6.06745 2.64733 6.1248C2.71514 6.18215 2.80706 6.21443 2.90295 6.21454H3.62689C3.72296 6.21454 3.8151 6.18226 3.88303 6.1248C3.95096 6.06734 3.98913 5.9894 3.98913 5.90814C3.98913 5.82688 3.95096 5.74895 3.88303 5.69148C3.8151 5.63402 3.72296 5.60174 3.62689 5.60174H2.90242C2.80644 5.60186 2.71444 5.63419 2.64662 5.69164C2.5788 5.74909 2.54071 5.82696 2.54071 5.90814V5.90859H2.54124Z" fill="currentColor"/>
                    </svg>

                    {{ $t("My Gift Cards") }}
                  </router-link>
                </li>
                <li v-if="appConfig.supportsEgiftCards">
                  <router-link to="/gift-cards/purchase" @click.native="menuClickHandler">
                    <span class="uk-margin-small-right" uk-icon="icon: cart"></span>
                    {{ $t("Buy Gift Card") }}
                  </router-link>
                </li>
                <div v-if="!isAutoLogin && usesSubscriptions && !hasValidSubscription">
                <li class="uk-nav-divider"></li>
                <li class="uk-nav-header">{{ $t("Subscriptions") }}</li>
                <li>
                  <router-link to="/subscription" @click.native="menuClickHandler">
                    <span class="uk-margin-small-right" uk-icon="icon: cart"></span>
                    <span :class="linkItemClass">{{ $t("Subscriptions") }}</span>
                  </router-link>
                </li>
                </div>
                <div v-if="!isAutoLogin">
                <li class="uk-nav-divider"></li>
                <li class="uk-nav-header">{{ $t("Profile") }}</li>
                <li>
                  <router-link to="/profile" @click.native="menuClickHandler">
                    <span class="uk-margin-small-right" uk-icon="icon: user"></span>
                    <span :class="linkItemClass">{{ $t("ViewProfile") }}</span>
                  </router-link>
                </li>
                </div>
              </div>
              <div v-if="!isAutoLogin">
                <li v-if="isLoggedIn || isMerchantMode">
                  <a v-on:click="logout" href="#">
                  <span class="uk-margin-small-right" uk-icon="icon: lock"></span>
                    <span :class="linkItemClass">{{ $t("LogOut") }}</span>
                  </a>
                </li>
                <li v-else>
                  <a v-on:click="logout" href="#">
                    <span class="uk-margin-small-right" uk-icon="icon: lock"></span>
                    <span :class="linkItemClass">{{ $t("Login") }}</span>
                  </a>
                </li>
              </div>
              <li class="uk-nav-divider"></li>
              <!--<li>-->
                <!--<router-link to="/eula" @click.native="menuClickHandler">-->
                  <!--<span class="uk-margin-small-right" uk-icon="icon: link"></span>-->
                  <!--End User License Agreement-->
                <!--</router-link>-->
              <!--</li>-->
              <!--<li>-->
                <!--<router-link to="/privacy" @click.native="menuClickHandler">-->
                  <!--<span class="uk-margin-small-right" uk-icon="icon: link"></span>-->
                  <!--Privacy Policy-->
                <!--</router-link>-->
              <!--</li>-->
              <!--<li class="uk-nav-header">Development</li>-->
                <!--<router-link to="/locations-by-region/61b5a225-6de4-4cc7-9a29-66241e0b298e">-->
                  <!--<span class="uk-margin-small-right" uk-icon="icon: link"></span>-->
                  <!--Location By Region-->
                <!--</router-link>-->
              <!--<li v-on:click="testGeneral">-->
                <!--<a href="#">-->
                <!--<span class="uk-margin-small-right" uk-icon="icon: link"></span>-->
                  <!--Loyalty Scan/Stamp-->
                <!--</a>-->
              <!--</li>-->
              <!--<li v-on:click="testLoyaltyRedeem">-->
                <!--<a href="#">-->
                  <!--<span class="uk-margin-small-right" uk-icon="icon: link"></span>-->
                  <!--Loyalty Redemption-->
                <!--</a>-->
              <!--</li>-->
              <!--<li v-on:click="testVoucherRedeem">-->
                <!--<a href="#">-->
                  <!--<span class="uk-margin-small-right" uk-icon="icon: link"></span>-->
                  <!--Coupon Redemption-->
                <!--</a>-->
              <!--</li>-->
              <!--<li v-on:click="clearVuex">-->
                <!--<a href="#">-->
                  <!--<span class="uk-margin-small-right" uk-icon="icon: link"></span>-->
                  <!--Delete All Data-->
                <!--</a>-->
              <!--</li>-->
              <!--<li v-on:click="refreshVuex">-->
                <!--<a href="#">-->
                  <!--<span class="uk-margin-small-right" uk-icon="icon: link"></span>-->
                  <!--Refresh Data-->
                <!--</a>-->
              <!--</li>-->

<!--              <span>{{ $t("locationCount") }}: {{ locationCount }}</span> <br/>-->
<!--              <span>{{ $t("CurrentPage") }}: {{ currentPage }}</span> <br/>-->
<!--              <span>{{ $t("TotalPage") }}: {{ totalPage }}</span> <br/>-->

            </ul>
        </div>
      <redemptionstatusmodal></redemptionstatusmodal>
    </div>
    <!--  // OFF CANVAS MENU -->
</template>
<script>
import redemptionstatusmodal from '../components/RedemptionStatusModal'
import configMixin from '../mixins/configMixin'
import localeMixin from '../mixins/localeMixin'
import Hub from '../events/Hub'
import store from '../store'
import UIkit from 'uikit'
import _ from 'lodash'

export default {
  components: {
    redemptionstatusmodal
  },
  mixins: [configMixin, localeMixin],
  data () {
    return {
      data: {},
      title: 'blah',
      type: 'redemption',
      hasValidSubscription: false
    }
  },
  computed: {
    usesSubscriptions () {
      return _.get(this.appConfig, 'usesCouponSubscription', false)
    },
    locationCount () {
      let locationsQuery = this.$store.getters.getAllListsFromLocal.locations.items
      return Object.keys(locationsQuery).length
    },
    currentPage () {
      return this.$store.state.current_page
    },
    totalPage () {
      return this.$store.state.total_pages
    },
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    },
    isMerchantMode () {
      return store.getters.appMode === 'merchant'
    },
    isHideLoyalty () {
      return _.get(this.appConfig, 'hide_loyalty')
    },
    isAutoLogin () {
      return _.get(this.appConfig, 'auto_login')
    },
    linkItemClass () {
      return {
        'text-rtl': this.shouldUseRtl
      }
    }
  },
  methods: {
    loadProductPurchaseDetails () {
      if (!this.appConfig.usesCouponSubscription) {
        this.hasValidSubscription = true
        return
      }

      let promise = this.getProductPurchaseStatus(this.appConfig.couponSubscriptionProduct.id)
      promise.then(response => {
        this.hasValidSubscription = response.data
      })
      promise.catch(error => {
        console.log(error)
        this.hasValidSubscription = false
      })
    },
    menuClickHandler: function () {
      UIkit.offcanvas('#offcanvas-nav').hide()
    },
    logout: function () {
      let _this = this
      UIkit.offcanvas('#offcanvas-nav').hide()
      this.$store.dispatch('logout')
        .then(function () {
          _this.$router.push('/login')
          console.log('User requested to logout - deleting all local cache.')
          _this.store.dispatch('entities/deleteAll')
        })
        .catch(err => console.log(err))
    },
    testGeneral: function () {
      let _this = this
      console.log('Test General Called')
      _this.redemptionIntent('test-success', 'earn-loyalty', {storeId: null, itemId: null, code: this.appConfig.dev.test_code})
    },
    testLoyaltyRedeem: function () {
      let _this = this
      console.log('Test Loyalty Redeem Called')
      _this.redemptionIntent('test-success', 'redeem-loyalty', {storeId: this.appConfig.dev.test_store_id,
        itemId: this.appConfig.dev.test_loyalty_id,
        code: null})
    },
    testVoucherRedeem: function () {
      let _this = this
      console.log('Test Voucher Redeem Called')
      _this.redemptionIntent('test-success', 'redeem-voucher', {storeId: this.appConfig.dev.test_store_id,
        itemId: this.appConfig.dev.test_coupon_id,
        code: this.appConfig.dev.test_code})
    },
    clearVuex: function () {
      store.dispatch('entities/deleteAll')
      console.log('Delete All Data')
    },
    refreshVuex: function () {
      this.$store.dispatch('requestLocation')
        .then()
        .catch(err => console.log(err))
    },
    openModal: function () {
      Hub.$emit('open-modal')
      Hub.$emit('set-redemption-status-model-data', this.data, this.title, this.type)
    }
  },
  mounted () {
    this.loadProductPurchaseDetails()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/OffCanvasMenu.vue